import { render, staticRenderFns } from "./BidInfo.vue?vue&type=template&id=c5797678&"
import script from "./BidInfo.vue?vue&type=script&lang=js&"
export * from "./BidInfo.vue?vue&type=script&lang=js&"
import style0 from "./BidInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports